// © Microsoft Corporation. All rights reserved.

import { chevron_left, ellipsis3 } from "../../utils/icons";

import { Button } from "@microsoft/fast-components-react-msft";
import React from "react";
import { SocialProps } from "../../Social.props";

export interface NavbarProps extends SocialProps{
    onBackClick?: (any) => void;
    onEllipsisClick?: (any) => void;
    whiteIcons?: boolean;
}

export default class Navbar extends React.Component<NavbarProps, {}> {
    containerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
    }

    /**
     * We do not render icons if matching handler os not passed
     */
    render() {
        const { managedClasses, onBackClick, onEllipsisClick, whiteIcons, t } = this.props;

        return (
            <div className={managedClasses.navbarContainer}>
                { onBackClick
                    ? <Button className="cwt-fast-button cwt-fast-icon-button cwt-navbar-button" aria-label={t.AriaLabelsGoBackButton} onClick={(e) => this.backClickHandler(e)}>
                        <i className={`cwt-icon ${whiteIcons ? "cwt-icon-white" : ""}`}> {chevron_left} </i>
                    </Button>
                    : <span className="cwt-placeholder"></span>
                }
                { onEllipsisClick
                    ? <Button className="cwt-fast-button cwt-fast-icon-button cwt-navbar-button" aria-label={t.AriaLabelsEllipsisButton} onClick={(e) => this.ellipsisClickHandler(e)}>
                        <i className={`cwt-icon ${whiteIcons ? "cwt-icon-white" : ""}`}> {ellipsis3} </i>
                    </Button>
                    : <span className="cwt-placeholder"></span>
                }
            </div>
        );
    }

    backClickHandler(e) {
        if (this.props.onBackClick) { this.props.onBackClick(e); }
    }

    ellipsisClickHandler(e) {
        if (this.props.onEllipsisClick) { this.props.onEllipsisClick(e); }
    }
}